import { type ReactNode, useRef } from 'react';
import { useLoomTracker } from '@/hooks/use-loom-tracker';

type Props = {
  videoId: string;
  title?: string;
  hideUi?: boolean;
  threshold?: number;
  onWatched?: () => void;
  onProgress?: (elapsed: number, duration: number) => void;
};

const PLACEHOLDER =
  'flex aspect-video w-full items-center justify-center rounded-lg border border-white/[0.08] bg-white/[0.05] text-text-tertiary backdrop-blur-xl';

const HIDE_PARAMS =
  'hideEmbedTopBar=true&hide_owner=true&hide_share=true&hide_title=true&hide_speed=true';

function buildSrc(videoId: string, hideUi: boolean): string {
  const base = `https://www.loom.com/embed/${videoId}`;
  return hideUi ? `${base}?${HIDE_PARAMS}` : base;
}

export function LoomEmbed(p: Props): ReactNode {
  const ref = useRef<HTMLIFrameElement>(null);
  useLoomTracker({
    iframeRef: ref,
    threshold: p.threshold ?? 0.95,
    onWatched: p.onWatched ?? noop,
    ...(p.onProgress ? { onProgress: p.onProgress } : {}),
  });
  if (!p.videoId) return <div className={PLACEHOLDER}>Video no disponible</div>;
  return (
    <iframe
      ref={ref}
      className="aspect-video w-full rounded-lg"
      src={buildSrc(p.videoId, p.hideUi ?? false)}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; fullscreen"
      allowFullScreen
      title={p.title ?? 'Loom video'}
    />
  );
}

function noop(): void {
  /* default when caller doesn't track */
}
